import { Component, EventEmitter, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, NgForm, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { ExposedListPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryPersonsRes';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { USER_ROLES } from 'common/constants/user-role.constants';
import { environment } from 'environments/environment';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogEditUserAddData {}

@Component({
    selector: 'dialog-settings-users-select',
    templateUrl: 'dialog-settings-users-select.html',
    styleUrls: ['dialog-settings-users-select.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogSettingsUsersSelect extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: FormGroup;
    formEnabled = true;
    userDetails: ExposedReadUserDetailsRes = null;
    submitted = false;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogSettingsUsersSelect>,
        private formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        private lsrauthService: LsrauthService,
        private alertsService: AlertsService,
        @Inject(MAT_DIALOG_DATA) public data: DialogEditUserAddData
    ) {
        super(dialogRef);
        this.lsrauthService.userDetails.subscribe((userDetails) => {
            this.userDetails = userDetails;
        });
        this.initForm();
    }

    checkHasSelectoryRole(): boolean {
        return (
            this.lsrauthService.inRole(this.userDetails, USER_ROLES.IMPERSONATION_LOAN_DOMAIN) ||
            this.lsrauthService.inRole(this.userDetails, USER_ROLES.IMPERSONATION_PENSION_DOMAIN)
        );
    }

    formatKennitala(kt) {
        return formatKennitala(kt);
    }

    userSelected = (option: ExposedListPublicRegistryPersonsRes | null) => {
        if (!option) {
            return;
        }
        this.form.get('ssn').setValue(option.ssn);
    };

    initForm() {
        this.submitted = false;
        this.form = this.formBuilder.group({
            ssn: new FormControl('', Validators.required),
            personSearchSearchInput: new UntypedFormControl(''),
            fullImpersonation: this.checkHasSelectoryRole() ? false : true,
            reason: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
        });
    }

    submitRequest() {
        // Make sure user can't sent two auth requests at the same time
        if (!this.formEnabled) {
            return;
        }

        // Make sure the user has selected a particular person.
        if (!this.form.get('ssn').value) {
            this.alertsService.changealertHeader('Villa kom upp');
            this.alertsService.changeAlertErrorMessage('Þú verður að tilgreina notanda');
            this.alertsService.changeAlertErrorShow(true);
            return;
        }
        if (this.form.get('reason').invalid) {
            this.alertsService.changealertHeader('Villa kom upp');
            this.alertsService.changeAlertErrorMessage('Þú verður að tilgreina ástæðu');
            this.alertsService.changeAlertErrorShow(true);
            return;
        }

        this.submitted = true;
        this.formEnabled = false;
        this.lsrauthService
            .changeClaimInfo(this.form.get('ssn').value, this.form.get('fullImpersonation').value, this.form.get('reason').value)
            .subscribe((res) => {
                if (res?.error?.errorItem) {
                    this.formEnabled = true;
                    this.alertsService.changealertHeader('Villa kom upp');
                    this.alertsService.changeAlertErrorMessage(res.error.errorItem.message);
                    this.alertsService.changeAlertErrorShow(true);
                } else {
                    const encodedAccessToken = encodeURIComponent(res.accessToken);
                    const encodedRefreshToken = encodeURIComponent(res.refreshToken);
                    const targetUrl = `${environment.customerPortalUrl}impersonate?accessToken=${encodedAccessToken}&refreshToken=${encodedRefreshToken}`;
                    window.open(targetUrl, '_blank');

                    this.close();
                }
            });
    }

    onConfirm = new EventEmitter();
}
